import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  ReceiptAdmin,
  ReceiptAdminParams,
  ReceiptAdminApiResponse,
} from "./ReceiptAdminType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

//情報取得API連携
export const fetchAsyncReceiptAdmin: any = createAsyncThunk<
  ReceiptAdminParams,
  number
>("ReceiptAdmin/get", async (page) => {
  const response = await axiosSettings.get(`api-admin/receipt?page=${page}`);
  return response.data;
});

const initialState: ReceiptAdmin = {
  receiptAdmin: null,
  updatedTime: "",
  loading: false,
  error: "",
};

const ReceiptAdminSlice = createSlice({
  name: "ReceiptAdmin",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncReceiptAdmin.fulfilled, (state, action) => {
      //トークン認証&通信成功、データを受け取る
      if (action.payload.status === "Success") {
        state.receiptAdmin = action.payload.data.result.data;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.data.result;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncReceiptAdmin.pending, (state, action) => {
      state.loading = true;
    });
    // builder.addCase(fetchAsyncReceiptAdmin.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload.data;
    // });
  },
});

export const receiptAdminInfo = (state: RootState) =>
  state.ReceiptAdmin.receiptAdmin;
export const receiptAdminError = (state: RootState) => state.ReceiptAdmin.error;
export const receiptAdminLoading = (state: RootState) =>
  state.ReceiptAdmin.loading;
export const receiptAdminUpdatedTime = (state: RootState) =>
  state.ReceiptAdmin.updatedTime;
export default ReceiptAdminSlice.reducer;
